var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13453_9896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 2.5H4.16667C3.062 2.50132 2.00296 2.94073 1.22185 3.72185C0.440735 4.50296 0.00132321 5.562 0 6.66667H20C19.9987 5.562 19.5593 4.50296 18.7782 3.72185C17.997 2.94073 16.938 2.50132 15.8333 2.5Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3333C0.00132321 14.438 0.440735 15.497 1.22185 16.2782C2.00296 17.0593 3.062 17.4987 4.16667 17.5H15.8333C16.938 17.4987 17.997 17.0593 18.7782 16.2782C19.5593 15.497 19.9987 14.438 20 13.3333V8.33334H0V13.3333ZM5.83333 12.9167C5.83333 13.1639 5.76002 13.4056 5.62267 13.6111C5.48532 13.8167 5.2901 13.9769 5.06169 14.0715C4.83328 14.1661 4.58195 14.1909 4.33947 14.1427C4.09699 14.0944 3.87427 13.9754 3.69945 13.8006C3.52463 13.6257 3.40558 13.403 3.35735 13.1605C3.30912 12.9181 3.33387 12.6667 3.42848 12.4383C3.52309 12.2099 3.68331 12.0147 3.88887 11.8773C4.09443 11.74 4.33611 11.6667 4.58333 11.6667C4.91485 11.6667 5.2328 11.7984 5.46722 12.0328C5.70164 12.2672 5.83333 12.5852 5.83333 12.9167Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13453_9896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.61290834fe19b0034bea2af06eb5183a.svg";
export { ForwardRef as ReactComponent };